













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/personne/edit/EditInformations.vue'
import { getDefaultAloPersonne, AloPersonne } from '@/models/alo/AloPersonne'

@Component({
  name: 'ReadInformations',    
  components:{Edit},  
  props: {
    loading:{
      type:Boolean,
      default:false
    },
    personne:{
      type:Object,
      default:getDefaultAloPersonne
    }    
  }
})
export default class ReadInformations extends Vue {
  
  private personne!:AloPersonne
  private loading!:boolean  

  edit() { 
    (this.$refs.edit as Edit).edit(this.personne)
  }

}
